var _circle, _g, _g2, _path, _path2, _g3, _path3, _path4, _circle2, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDominica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#496e2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306.087 507.087c101.203-20.076 180.924-99.798 201-201h-201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.913 306.087c20.075 101.202 99.797 180.924 201 201v-201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.087 205.913c-20.076-101.202-99.797-180.924-201-201v201z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.913 4.913c-101.203 20.076-180.925 99.798-201 201h201z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m239.304 306.087h-33.391v201c10.897 2.161 22.044 3.625 33.391 4.356z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.304 205.913v-205.356c-11.347.73-22.495 2.195-33.391 4.356v201z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m272.696.557c-5.522-.357-11.085-.557-16.696-.557s-11.174.2-16.696.557v205.357h33.391v-205.357z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m239.304 511.443c5.522.357 11.085.557 16.696.557s11.174-.2 16.696-.557v-205.356h-33.391v205.356z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m205.913 239.304v-33.391h-201c-2.162 10.898-3.626 22.044-4.356 33.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.087 239.304h205.357c-.73-11.347-2.195-22.493-4.356-33.391h-201v33.391z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m306.087 272.696h205.357c.356-5.521.556-11.085.556-16.696s-.2-11.175-.557-16.696h-205.356z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m.557 239.304c-.356 5.521-.557 11.085-.557 16.696s.201 11.175.557 16.696h205.357v-33.391h-205.357z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#d80027",
    r: 122.435
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#496e2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m283.894 269.66c-9.107-18.213-20.944-36.673-20.944-36.673s.294-8.405.294-13.413c0-7.544-6.116-13.66-13.66-13.66-7.147 0-13.003 5.491-13.6 12.482-5.62.367-10.067 5.029-10.067 10.741 0 4.153 2.353 7.752 5.797 9.551 1.712-4.004 5.064-7.13 9.21-8.555.676.553 1.402 1.047 2.177 1.466l1.75.838s-6.489 18.291-6.489 28.117c0 27.624 18.214 36.143 18.214 36.143v.285l-9.107 9.106h18.213v-18.214l9.107 9.107c.08-.171 17.25-11.03 9.105-27.321z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 155.826 4.144 12.754h13.41l-10.849 7.883 4.145 12.754-10.85-7.882-10.85 7.882 4.145-12.754-10.849-7.883h13.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.12 174.958 10.848 7.883 10.85-7.884-4.144 12.756 10.85 7.881-13.411.001-4.144 12.754-4.145-12.754-13.41-.001 10.849-7.883z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.729 225.045h13.409l4.145-12.754 4.144 12.754 13.411-.001-10.849 7.884 4.145 12.754-10.851-7.883-10.849 7.882 4.143-12.754z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.729 286.955 10.848-7.881-4.144-12.755 10.85 7.883 10.85-7.883-4.144 12.754 10.85 7.883-13.412.001-4.144 12.753-4.145-12.755z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.12 337.042 4.143-12.752-10.85-7.883h13.411l4.145-12.755 4.144 12.754h13.411l-10.85 7.884 4.144 12.753-10.85-7.883z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 356.174-4.144-12.752h-13.41l10.849-7.884-4.145-12.754 10.85 7.881 10.849-7.882-4.144 12.755 10.849 7.883-13.41.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.88 337.042-10.848-7.882-10.849 7.884 4.143-12.754-10.85-7.883 13.411-.001 4.143-12.754 4.146 12.755h13.41l-10.849 7.883z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.271 286.955h-13.409l-4.145 12.755-4.144-12.753h-13.412l10.85-7.884-4.145-12.753 10.851 7.882 10.848-7.882-4.142 12.754z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.271 225.045-10.848 7.882 4.143 12.754-10.849-7.882-10.85 7.884 4.144-12.755-10.85-7.882 13.412-.002 4.143-12.752 4.146 12.753z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.88 174.958-4.143 12.753 10.849 7.883h-13.41l-4.144 12.755-4.145-12.754-13.411.001 10.85-7.885-4.144-12.752 10.85 7.881z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominica);
export default __webpack_public_path__ + "static/media/dominica.1a52883e542ce4e335b82f1d248d5e4b.svg";
export { ForwardRef as ReactComponent };